

































import Translation from '@/mixins/Translation'
import ListItem from '@/components/list/ListItem.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import BankImg from '@/components/image/BankImg.vue'
import {namespace} from 'vuex-class'

const clients = namespace('clients')

@Component({
  components: {BttPopup, ListItem, BankImg}
})
export default class ClientAccountSelectionPopup extends Mixins(Translation) {
  @clients.State('clientAccounts') clientAccounts
  @clients.Mutation('clearAccounts') clearAccounts
  @clients.Mutation('updateSelectedClientAccount') updateSelectedClientAccount

  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: '', type: String}) clientId: string

  open: boolean = true

  @Watch('value', {immediate: true})
  __value(value) {
    if(!value) {
      this.clearAccounts()
    }
    this.open = value
  }

  onClickCancel() {
    this.$emit('on-popup')
    this.onHandlePopup(false)
  }

  onClickAccountItem(clientBankAccount) {
    if(clientBankAccount) {
      this.updateSelectedClientAccount(clientBankAccount)
      this.$emit('open-update-popup')
      this.onHandlePopup(false)
    }
  }

  onClickDelete(account) {
    const {id} = account
    this.$emit('delete', this.clientId, id)
    this.onHandlePopup(false)
  }

  onClickCreate() {
    this.$emit('open-create-popup')
    this.onHandlePopup(false)
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }
}
